import { Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  licenseFeatures: {
    id: 'newAccount.step.licenseFeatures',
    defaultMessage: '1. License & features',
  },
  patientPlans: {
    id: 'newAccount.step.patientPlans',
    defaultMessage: '2. Patient plans',
  },
});

const STEPS = [messages.licenseFeatures, messages.patientPlans];

interface WizardStepIndicatorProps {
  /** Zero-based index of the step currently being filled in */
  currentStep: number;
}

export default function WizardStepIndicator({
  currentStep,
}: WizardStepIndicatorProps) {
  const { formatMessage } = useIntl();

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      {STEPS.map((step, index) => {
        const active = index === currentStep;

        return (
          <React.Fragment key={step.id}>
            {index > 0 && (
              <Stack borderColor="divider" borderTop={1} width={16} />
            )}
            <Stack
              bgcolor={active ? 'primary.main' : 'action.hover'}
              borderRadius={2}
              data-testid={`wizard-step-${index}`}
              px={2}
              py={1}
            >
              <Typography
                color={active ? 'primary.contrastText' : 'text.disabled'}
                variant="subtitle2"
              >
                {formatMessage(step)}
              </Typography>
            </Stack>
          </React.Fragment>
        );
      })}
    </Stack>
  );
}
